<template>
  <footer>
    <v-container class="v-application" :fluid="true" style="height:60px;padding:0px">
      <v-row>
        <v-col sm="1" class="d-none d-md-block">
          <!-- Logo del EBOOK -->
          <template v-if="config.mostrarLogo">
            <img :src="logoEbook()" class="footer_logo ml-1" alt="logo" />
          </template>
          
        </v-col>
        <v-col sm="12" md="10" class="pt-0">
          <v-row justify="center">
            <!--INICIO UNIDADES-->
            <v-col v-if="config.mostrarUnidades" sm="2" lg="1" class="pt-0 d-none d-md-block">
              <div class="contBtnUnits text-center">
                <div @click="showUnidades = !showUnidades">
                  <div style="margin-top:0px">{{literal["UNIDADES"]["TITULO"]}}</div>
                  <div class="imgUnits"></div>
                </div>

                <template  v-if="showUnidades">

                  <template v-if="this.ebook [this.$store.state.indexLM].unidades.length < 7">
                    <div id="ContBtnUnits" class="units"
                    :style="'left:'+ -1*(60 + config.tamanioUnidad - 300)+'px;width:'+config.tamanioUnidad+'px;top: -' + ((this.ebook [this.$store.state.indexLM].unidades.length) * 40 + 40 + 13) + 'px; height: ' + ((this.ebook [this.$store.state.indexLM].unidades.length) * 40 + 40 + 4) + 'px'">
                      <p class="titleunits">{{literal["UNIDADES"]["SUBTITULO"]}}</p>
                      <div class="contHidden" :style="'height: ' + (this.ebook  [this.$store.state.indexLM].unidades.length) * 40 + 'px'">
                        
                        <!-- Se realiza el siguiente for para crear los botonoes de unidades -->
                        <template v-for="(lm, index) in this.ebook  [this.$store.state.indexLM].unidades">
                          <div class="contoptunit" @click="irUnidad({unitIndex:lm.pagInicialIndex, unit: lm.pagInicial})" :key="index">
                            <span class="option">{{ lm.nombre }}</span>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>

                  <template v-else>
                    <div id="ContBtnUnits" class="units"
                    :style="'width:'+config.tamanioUnidad+'px;top: -360px; height: 351px'">
                      <p class="titleunits">{{literal["UNIDADES"]["SUBTITULO"]}}</p>
                      <div class="contHidden" :style="'overflow: auto;height: 306px'">
                        
                        <!-- Se realiza el siguiente for para crear los botonoes de unidades -->
                        <template v-for="(lm, index) in this.ebook  [this.$store.state.indexLM].unidades">
                          <div class="contoptunit" @click="irUnidad({unitIndex:lm.pagInicialIndex, unit: lm.pagInicial})" :key="index">
                            <span class="option">{{ lm.nombre }}</span>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </template>
                
              </div>
            </v-col>
            <!--FINAL UNIDADES-->
            
            <!--Solo aparecera cuando este en modo mobile-->
            <Sidebar></Sidebar>

            <!--INICIO BOTON DOBLE PAGINA-->
            <v-col v-if="$store.state.config.esBinario" sm="2" lg="1" class="pt-0 text-center d-none d-md-block">
              <i id="btnPages" @click="doublePage()" class="icon-double color-11"></i>
            </v-col>
            <!--FINAL BOTON DOBLE PAGINA-->
            <!--INICIO PAGINADO-->
            <v-col sm="3" lg="2" class="pt-1">
              <div class="contBtnPagination">
                <v-img @click="atras()" class="arrowBtn btnPaginationLeft isInactive" 
                      src="@/assets/img/next.svg" height="30" contain></v-img>
                <input class="inputPagination ml-0 mr-0" maxlength="4" type="text" @blur="blur" @focus="focus" @click="focus" :value="mostrarPagina" @keyup.enter="irPagina"/>
                <v-img @click="siguiente()" class="arrowBtn btnPaginationRight" 
                      src="@/assets/img/next.svg" height="30" contain></v-img>
              </div>
            </v-col>
            <!--FINAL PAGINADO-->
            <Zoom class="d-none d-md-block"></Zoom>
            <!--INICIO RECURSOS-->
            <v-col sm="2" lg="1" class="pt-0 text-center">
              <i @click="setModalResource(true);setTypeModalResource('typeResourceView')" :class="(ebook[$store.state.indexLM].desactivarRecurso?'isInactiveCanvas': '') + ' icon-media color-11'"></i>
            </v-col>
            <!--FINAL RECURSOS-->
          </v-row>
        </v-col>

        <!--PDF HELP-->
        <v-col class="d-none d-md-block" sm="1" lg="1">
          <v-img v-if="config.mostrarAyuda" @click="openHelp()" src="@/assets/img/help.png" style="cursor:pointer;" class="float-right" height="35" contain></v-img>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
import $ from "jquery";

import Zoom from "./herramientas/Zoom";
import Sidebar from "./herramientas/Sidebar";

export default {
  name: "Footer",

  /**
   * Aqui se agregar los componentes
   */
  components: {
    Zoom,
    Sidebar
  },
  data: () => ({
    showUnidades: false,
    leftContenedorDoble: 0,
    leftContenedorSingle: 0,
    flag: true
  }),
  methods: {
      logoEbook(){
        try{
            let logo = this.$store.state.ebook[this.$store.state.indexLM].logo;
            let existeImg = require("@/assets/img/" + logo); 
            return existeImg;
          } catch {
            return ''
        }
    },
    /**
     * Abre el pdf HELP
     */
    openHelp(){
      window.open("recursos/DOCUMENTOS/help.pdf", "_blank");
    },
    doublePage() {
      if ($("#viewer").hasClass("double")) {
        $("#viewer").addClass("single");
        $("#viewer").removeClass("double");

        $("#btnPages").addClass("icon-document");
        $("#btnPages").removeClass("icon-double");
        this.setTwoPages(false);
      } else if ($("#viewer").hasClass("single")) {

        $("#viewer").removeClass("single");
        $("#viewer").addClass("double");

        $("#btnPages").addClass("icon-double");
        $("#btnPages").removeClass("icon-document");
        this.setTwoPages(true);

        if(this.$store.state.index != 0 && this.$store.state.index % 2 != 1){
          this.$store.state.index--;
        }

        if(this.$store.state.index == 0 || this.$store.state.index == this.ebook[this.$store.state.indexLM].paginas.length - 1){
          $("#viewer").addClass("single");
        }

        this.$store.commit('limites', this.twoPages);
      }
      this.$store.commit('resetearCanvas');
    },

    /**
     * Va a la pagina que se ingreso en la caja de paginas
     */
    irPagina(e){
      
      let pagina = e.target.value;
      pagina = pagina.trim();
      // if(this.isMobile){
        
      //   this.buscarPaginaMobile(pagina);

      // } else {
        this.buscarPagina(pagina);
      // }
      
      e.target.value = '';
    },

    irUnidad(payload){
      this.showUnidades = false;
      this.buscarLMUnidad(payload);
      // this.buscarPagina(pagina);
    },

    /**
     * Cuando se enfoca en la caja de paginas, este limpia su contenido
     */
    focus(e){
      e.target.value = '';
    },

    /**
     * Cuando no se enfoca en la caja de paginas, este lo rellena en la pagina que se encuentra actualmente
     */
    blur(e){
      e.target.value = this.mostrarPagina;
    },
    ...mapMutations(["setModalResource", "setTwoPages", "buscarPagina", "buscarPaginaMobile", "setTypeModalResource", "buscarLMUnidad", "siguiente", "atras"]) 
  }, 
  created() {
    //Se crea eventos de teclado para la tecla izquierda y derecha
    window.addEventListener('keydown', (e) => {
      if (e.key == 'ArrowRight' && !this.openResource && !$(".inputPagination").prop('disabled')) {
       this.siguiente();
      }
      if (e.key == 'ArrowLeft' && !this.openResource && !$(".inputPagination").prop('disabled')) {
       this.atras();
      }
    });
  },
  mounted: function(){
    if(this.$store.state.index == 0){
      let viewer = document.getElementById('viewer')
      viewer.classList.add('single')
    }
  },
  computed: {

    /**
     * Muestra las paginas en la caja de paginas
     */
    mostrarPagina() {
      let numberPageOne = '';
      let numberPageTwo = '';
      
      this.service.setIndexEbook({"page":this.$store.state.index, "lm":this.$store.state.indexLM})
      if(this.$store.state.index == 0 || this.$store.state.index == this.ebook[this.$store.state.indexLM].paginas.length - 1){ 
        return this.ebook[this.$store.state.indexLM].paginas[this.$store.state.index]
      }
      
      if(this.twoPages)
        return this.ebook[this.$store.state.indexLM].paginas[this.$store.state.index] + ` - ` + this.ebook[this.$store.state.indexLM].paginas[this.$store.state.index + 1]
      else
        
        return this.ebook[this.$store.state.indexLM].paginas[this.$store.state.index]
    },
    ...mapState(['literal', 'ebook','twoPages', 'isMobile', 'service', 'openResource', 'config'])
  }
};
</script>

<style>
/* INPUT DE ENUMERACION DE PAGINA */
.inputPagination {
  background: white;
  height: 27px;
  border-radius: 5px;
  text-align: center;
  font-size: 20px; /*Cambio 24/03/2020*/
  line-height: 24px;
  width: 102px;
  outline: none;
  margin: 0 10px;
  text-align: center;
}
.contBtnPagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 11px;
}

.contBtnPagination .inputPagination::-webkit-inner-spin-button,
.contBtnPagination .inputPagination::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.contBtnPagination .btnPaginationLeft {
  transform: rotate(180deg);
}

.contBtnPagination .btnPaginationLeft,
.contBtnPagination .btnPaginationRight {
  cursor: pointer;
  color: #fff;
  width: 30px;
  height: 30px;
  position: relative;
}

.isInactive {
  pointer-events: none;
  opacity: .7;
}

/*LOGO QUE APARECE EN EL FOOTER*/

.footer_logo {
  height: 45px;
  width: 143.52px;
  position: absolute;
  left: 1%;
  display: flex;
  align-items: center;
}

/*BOTON UNIDADES*/

.contBtnUnits {
  cursor: pointer;
  width: auto;
  transform: scale(0.8);
}
.contBtnUnits .imgUnits {
  background-image: url("../assets/img/barra.png");
  width: 76px;
  height: 40px;
  transform: scale(0.6);
  margin: 0 auto;
}

.units {
  /* display:none; */
  background-color: #3c3c3b;
  text-align: center;
  height: 84px;
  position: absolute;
  width: 290px;
  left: -50px;
  margin-left: -65.5px;
  top: -91px;
  border-radius: 5px 5px 0 0;
}

.contoptunit {
  position: relative;
  text-align: center;
  /* width: 173px; */
  cursor: pointer;
  padding: 2px;
  border: 0;
  background: #3c3c3b;
  color: #7b7b7b;

  /* -webkit-transform: translateX(-16px);
  transform: translateX(-16px);
  -moz-transform: translateX(-16px); */
  top: -2px;
}
.v-application p {
  margin-bottom: 0px !important;
}
.contBtnUnits .btnTitleUnits {
  margin: 0;
  text-align: center;
  color: #fff;
  font-size: 1.6em;
  cursor: pointer;
}

.contoptunit::-webkit-scrollbar,
.contAddBtnLink::-webkit-scrollbar {
  width: 0;
  padding: 0;
  background-color: #b5b5b5;
}
.contoptunit::-moz-scrollbar,
.contAddBtnLink::-moz-scrollbar {
  width: 0;
  background-color: #b5b5b5;
  padding: 0;
}

.contHidden {
  text-align: center;
  overflow: hidden;
  width: 100% !important;
  /* height: 100% !important; */
  background-color: transparent;
  position: relative;
  margin: 0 auto;
  padding-left: 18px;
  padding-right: 18px;
}

.titleunits {
  text-align: center;
  color: #fff;
  font-size: 28px;
  /* cursor: pointer; */
  margin: 2px 0;
}

.option {
  color: white;
  font-size: 22px;
  display: block;
  text-align: center;
  margin-bottom: 4px;
  margin-left: -3px;
}
.option:hover {
  color: black;
  background-color: white;
}
.option:active {
  color: #3c3c3b;
  background-color: white;
}
</style>